/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DropTikTokVideoResponse
 */
export interface DropTikTokVideoResponse {
    /**
     * 
     * @type {string}
     * @memberof DropTikTokVideoResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DropTikTokVideoResponse
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof DropTikTokVideoResponse
     */
    authorHandle: string;
    /**
     * 
     * @type {string}
     * @memberof DropTikTokVideoResponse
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof DropTikTokVideoResponse
     */
    authorName?: string;
    /**
     * 
     * @type {string}
     * @memberof DropTikTokVideoResponse
     */
    embedHtml?: string;
    /**
     * 
     * @type {string}
     * @memberof DropTikTokVideoResponse
     */
    thumbnailUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof DropTikTokVideoResponse
     */
    thumbnailWidth?: number;
    /**
     * 
     * @type {number}
     * @memberof DropTikTokVideoResponse
     */
    thumbnailHeight?: number;
    /**
     * Backend-proxied cover thumbnail. Populated only for OAuth-connected creators, whose videos render in our own cards; never set on the embed path.
     * @type {string}
     * @memberof DropTikTokVideoResponse
     */
    coverImageProxyUrl?: string | null;
}

/**
 * Check if a given object implements the DropTikTokVideoResponse interface.
 */
export function instanceOfDropTikTokVideoResponse(value: object): value is DropTikTokVideoResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('url' in value) || value['url'] === undefined) return false;
    if (!('authorHandle' in value) || value['authorHandle'] === undefined) return false;
    return true;
}

export function DropTikTokVideoResponseFromJSON(json: any): DropTikTokVideoResponse {
    return DropTikTokVideoResponseFromJSONTyped(json, false);
}

export function DropTikTokVideoResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropTikTokVideoResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'url': json['url'],
        'authorHandle': json['authorHandle'],
        'title': json['title'] == null ? undefined : json['title'],
        'authorName': json['authorName'] == null ? undefined : json['authorName'],
        'embedHtml': json['embedHtml'] == null ? undefined : json['embedHtml'],
        'thumbnailUrl': json['thumbnailUrl'] == null ? undefined : json['thumbnailUrl'],
        'thumbnailWidth': json['thumbnailWidth'] == null ? undefined : json['thumbnailWidth'],
        'thumbnailHeight': json['thumbnailHeight'] == null ? undefined : json['thumbnailHeight'],
        'coverImageProxyUrl': json['coverImageProxyUrl'] == null ? undefined : json['coverImageProxyUrl'],
    };
}

export function DropTikTokVideoResponseToJSON(json: any): DropTikTokVideoResponse {
    return DropTikTokVideoResponseToJSONTyped(json, false);
}

export function DropTikTokVideoResponseToJSONTyped(value?: DropTikTokVideoResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'url': value['url'],
        'authorHandle': value['authorHandle'],
        'title': value['title'],
        'authorName': value['authorName'],
        'embedHtml': value['embedHtml'],
        'thumbnailUrl': value['thumbnailUrl'],
        'thumbnailWidth': value['thumbnailWidth'],
        'thumbnailHeight': value['thumbnailHeight'],
        'coverImageProxyUrl': value['coverImageProxyUrl'],
    };
}

